import type { RoundExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const roundResolver =
  createSimpleNamedExpressionResolver<RoundExpression>(
    'round',
    (value, fractionDigits) => Number(value.toFixed(fractionDigits))
  );
